var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('side-bar',{staticClass:"d-none d-lg-block",attrs:{"items":_vm.filteredItems,"width":_vm.sideBarWidth}}),_c('bottom-bar',{staticClass:"d-lg-none",attrs:{"items":_vm.filteredItems,"height":_vm.bottomBarHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }